export default "__VITE_ASSET__D1GJrzmJ__"